export async function sendAccessTokenRequest() {
  return fetch(
    `${window.location.origin}/auth/instance/${
      import.meta.env.VITE_SCRIVITO_TENANT
    }/token?audience=${encodeURIComponent(
      import.meta.env.VITE_JR_API_AUDIENCE
    )}`,
    { credentials: "include" }
  )
}

export function fetchLoginURL(): Promise<string | null> {
  return sendAccessTokenRequest().then(response => {
    if (response.ok) {
      // eslint-disable-next-line no-console
      console.error("already logged in")
      return null
    }
    return response.json().then(res => res?.details?.visit)
  })
}
